<template>
  <div class="price-container">
    <!-- 筛选表单 -->
    <div class="filter-form">
      <el-form :model="filterForm" inline class="filter-form-content">
        <el-form-item :label="$t('domainPrice.domainSuffix')">
          <el-select v-model="filterForm.suffix" :placeholder="$t('domainPrice.enterDomainSuffix')" clearable filterable
            style="width: 150px;">
            <el-option v-for="suffix in suffixes" :key="suffix" :label="suffix" :value="suffix"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('domainPrice.operationType')">
          <el-select v-model="filterForm.type" :placeholder="$t('domainPrice.selectOperationType')" clearable
            style="width: 150px;">
            <el-option :label="$t('domainPrice.register')" value="register"></el-option>
            <el-option :label="$t('domainPrice.renew')" value="renew"></el-option>
            <el-option :label="$t('domainPrice.transfer')" value="transfer"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('domainPrice.years')">
          <el-select v-model="filterForm.years" :placeholder="$t('domainPrice.selectYears')" clearable
            style="width: 120px;">

            <el-option v-for="i in 10" :key="i" :label="i + $t('domain.year')" :value="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">{{ $t('system.search') }}</el-button>
        </el-form-item>
      </el-form>

      <el-button :loading="syncLoading" @click="handleSync">{{ $t('domainPrice.syncPriceList') }}</el-button>
      <el-button type="warning" @click="handleBatchUpdatePrice">{{ $t('domainPrice.batchUpdatePrice') }}</el-button>
    </div>

    <!-- 价格表格 -->
    <el-table :data="priceList" border v-loading="loading" style="width: 100%">
      <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
      <el-table-column prop="suffix" :label="$t('domainPrice.domainSuffix')" align="center">
        <template slot-scope="scope">
          <span class="suffix-text">{{ scope.row.suffix }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" :label="$t('domainPrice.operationType')" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="getTypeTagType(scope.row.type)">{{ getTypeText(scope.row.type) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="years" :label="$t('domainPrice.years')" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.years }}{{ $t('domain.year') }}
        </template>
      </el-table-column>
      <el-table-column prop="cost_price" :label="$t('domainPrice.costPrice')" width="120" align="center">
        <template slot-scope="scope">
          <span class="price-text">${{ scope.row.cost_price }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" :label="$t('domainPrice.currentPrice')" width="120" align="center">
        <template slot-scope="scope">
          <span class="price-text price-current">${{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('domainPrice.profit')" width="120" align="center">
        <template slot-scope="scope">
          <span :class="getProfitClass(scope.row)">${{ getProfit(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('domainPrice.updateTime')" width="180" align="center">
        <template slot-scope="scope">
          {{ formatDate(scope.row, 'update_time') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('layout.operation')" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.row)">{{ $t('domainTemplate.edit') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DomainPrice',
  data() {
    return {
      // 筛选表单
      filterForm: {
        suffix: '',
        type: '',
        years: null
      },
      // 表格数据
      priceList: [],
      // 域名类型
      suffixes: [],

      // 加载状态
      loading: false,
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      // 同步loading状态
      syncLoading: false,
    }
  },
  created() {
    this.fetchPriceList()
  },
  methods: {
    // 获取价格列表
    fetchPriceList() {
      this.loading = true

      // 构建API请求参数
      const params = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize,
        ...this.filterForm
      }

      // 移除空值
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key]
        }
      })

      // 发起API请求获取价格列表
      this.axios.post('/admin/domain/getDomainPriceTable', params, {
        token: true
      }).then(res => {
        const { status, data } = res
        const { code, msg } = data;
        
        if (status === 200 && data && code === 1) {
          const { list, total, suffixes } = data.data
          this.priceList = list || []
          this.pagination.total = total || 0
          this.suffixes = suffixes || [];
        } else {
          this.$message.error(msg || this.$t('domainPrice.fetchPriceListFailed'))
          this.priceList = []
        }

        this.loading = false
      }).catch(error => {
        console.error('获取价格列表失败:', error)
        this.$message.error(this.$t('domainPrice.fetchPriceListFailed'))
        this.loading = false
        this.priceList = []
      })
    },

    // 格式化日期
    formatDate(row, column) {
      const date = row[column]
      if (!date) return '--'

      // 处理时间戳格式
      const timestamp = typeof date === 'number' ? date * 1000 : date
      const d = new Date(timestamp)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')

      return `${year}-${month}-${day} ${hour}:${minute}`
    },

    // 获取操作类型文本
    getTypeText(type) {
      const typeMap = {
        'register': this.$t('domainPrice.register'),
        'renew': this.$t('domainPrice.renew'),
        'transfer': this.$t('domainPrice.transfer')
      }
      return typeMap[type] || type
    },

    // 获取操作类型标签类型
    getTypeTagType(type) {
      const typeMap = {
        'register': 'success',
        'renew': 'warning',
        'transfer': 'info'
      }
      return typeMap[type] || ''
    },

    // 计算利润
    getProfit(row) {
      const profit = parseFloat(row.price) - parseFloat(row.cost_price)
      return profit.toFixed(2)
    },

    // 获取利润样式类
    getProfitClass(row) {
      const profit = parseFloat(row.price) - parseFloat(row.cost_price)
      if (profit > 0) {
        return 'profit-positive'
      } else if (profit < 0) {
        return 'profit-negative'
      } else {
        return 'profit-zero'
      }
    },

    // 表单利润计算
    getFormProfit() {
      const profit = parseFloat(this.priceForm.price) - parseFloat(this.priceForm.cost_price)
      return profit.toFixed(2)
    },

    // 表单利润样式类
    getFormProfitClass() {
      const profit = parseFloat(this.priceForm.price) - parseFloat(this.priceForm.cost_price)
      if (profit > 0) {
        return 'profit-positive'
      } else if (profit < 0) {
        return 'profit-negative'
      } else {
        return 'profit-zero'
      }
    },

    // 处理搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchPriceList()
    },

    // 处理同步
    handleSync() {
      this.$confirm(this.$t('domainPrice.syncConfirm'), this.$t('system.prompt'), {
        confirmButtonText: this.$t('system.confirm'),
        cancelButtonText: this.$t('system.cancel'),
        type: 'warning'
      }).then(() => {
        this.syncLoading = true
        this.axios.post('/admin/domain/syncDomainAllPrice', {}, {
          token: true
        }).then(res => {
          this.syncLoading = false
          const { status, data } = res;
          const { code, msg } = data;
          
          if (status === 200 && code === 1) {
            this.$message({
              type: 'success',
              message: msg || this.$t('domainPrice.syncSuccess')
            })
            // 重新获取列表
            this.fetchPriceList()
          } else {
            this.$message.error(msg || this.$t('domainPrice.syncFailed'))
          }
        })
      })
    },

    // 处理页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchPriceList()
    },

    // 处理每页条数变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.fetchPriceList()
    },

    // 处理编辑
    handleEdit(row) {
      this.$prompt(this.$t('domainPrice.enterCurrentPrice') + "($)", this.$t('domainPrice.editPrice'), {
        confirmButtonText: this.$t('system.confirm'),
        cancelButtonText: this.$t('system.cancel'),
        inputPattern: /^\d+(\.\d{1,2})?$/,
        inputErrorMessage: this.$t('domainPrice.priceFormat'),
        inputValue: row.price
      }).then(({ value }) => {
        console.log(value);
        
        if (Number(value) < Number(row.cost_price)) {
          this.$message.error(this.$t('domainPrice.priceLessThanCost'));
          return;
        }
        // 发起API请求更新价格
        this.axios.post('/admin/domain/updateDomainPrice', {
          id: row.id,
          price: value
        }, {
          token: true
        }).then(res => {
          const { status, data } = res;
          const { code, msg } = data;
          if (status === 200 && code === 1) {
            this.$message({
              type: 'success',
              message: msg || this.$t('domainPrice.updateSuccess')
            })
            // 重新获取列表
            this.fetchPriceList()
          } else {
            this.$message.error(msg || this.$t('domainPrice.updateFailed'))
          }
        }).catch(error => {
          console.error('更新价格失败:', error)
          this.$message.error(this.$t('domainPrice.updateFailed'))
        })
      }).catch(() => {
      })
    },

    // 批量修改价格
    handleBatchUpdatePrice() {
      this.$prompt(this.$t('domainPrice.enterProfitRatio') + '(%)', this.$t('domainPrice.batchUpdatePrice'), {
        confirmButtonText: this.$t('system.confirm'),
        cancelButtonText: this.$t('system.cancel'),
        inputPattern: /^\d+(\.\d{1,2})?$/,
        inputErrorMessage: this.$t('domainPrice.profitRatioFormat'),
        inputValue: '20'
      }).then(({ value }) => {
        const profitRatio = parseFloat(value)
        if (profitRatio < 0) {
          this.$message.error(this.$t('domainPrice.profitRatioMustPositive'))
          return
        }

        // 构建筛选参数
        const params = {
          profitRatio: profitRatio,
          ...this.filterForm
        }

        // 移除空值
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })

        this.$confirm(this.$t('domainPrice.batchUpdateConfirm', { ratio: profitRatio }), this.$t('system.prompt'), {
          confirmButtonText: this.$t('system.confirm'),
          cancelButtonText: this.$t('system.cancel'),
          type: 'warning'
        }).then(() => {
          // 发起API请求批量更新价格
          this.axios.post('/admin/domain/batchUpdateDomainPrice', params, {
            token: true
          }).then(res => {
            const { status, data } = res;
            const { code, msg } = data;
            if (status === 200 && code === 1) {
              this.$message({
                type: 'success',
                message: msg || this.$t('domainPrice.batchUpdateSuccess')
              })
              // 重新获取列表
              this.fetchPriceList()
            } else {
              this.$message.error(msg || this.$t('domainPrice.batchUpdateFailed'))
            }
          }).catch(error => {
            console.error('批量更新价格失败:', error)
            this.$message.error(this.$t('domainPrice.batchUpdateFailed'))
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('system.cancel')
          })
        })
      }).catch(() => {
      })
    },
  }
}
</script>

<style scoped>
.price-container {
  padding: 20px;
}

.filter-form {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.filter-form-content {
  margin: 0;
}

.suffix-text {
  font-weight: bold;
  color: #409EFF;
}

.price-text {
  font-weight: bold;
}

.price-current {
  color: #67C23A;
}

.profit-positive {
  color: #67C23A;
  font-weight: bold;
}

.profit-negative {
  color: #F56C6C;
  font-weight: bold;
}

.profit-zero {
  color: #909399;
  font-weight: bold;
}

.delete-btn {
  color: #F56C6C;
}

.delete-btn:hover {
  color: #F56C6C;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}

/* 表格样式优化 */
.el-table {
  border-radius: 4px;
  overflow: hidden;
}

.el-table th {
  background-color: #fafafa;
  color: #333;
  font-weight: bold;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .filter-form-content .el-form-item {
    margin-bottom: 10px;
  }

  .pagination-container {
    text-align: center;
  }
}
</style>